import { render, staticRenderFns } from "./indexEmpty.vue?vue&type=template&id=95923354&scoped=true&"
import script from "./indexEmpty.vue?vue&type=script&lang=js&"
export * from "./indexEmpty.vue?vue&type=script&lang=js&"
import style0 from "./indexEmpty.vue?vue&type=style&index=0&id=95923354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95923354",
  null
  
)

export default component.exports